import { TRegistrationFormValues } from './RegistrationForm.types';

export const REGISTRATION_FORM_DEFAULT_VALUES: TRegistrationFormValues = {
  email: '',
  password: '',
};
